/**
 * Bob Laadt Op — bob-obflow ("Zo gaat dat bij mij"): bladeren door de batterijen.
 * Bron: _design/Bob-laadt-op-thomas/werkbestanden/paginas/batterijen-vergelijken.html r. 1791–1814
 * (zelfde script op over-bob.html).
 *
 * De foto en de kaart links horen bij elkaar, dus één index stuurt ze allebei. Rondgaand,
 * want er zijn geen stippen die vertellen waar het einde is. De kaart kleurt mee met het
 * product; die kleur staat op de tekst zelf (data-flow-kleur).
 *
 * Custom element rond .obflow-grid, zodat het na een re-render in de theme editor opnieuw
 * werkt. Alleen geladen als de sectie 2+ slides heeft.
 */
class BobObflow extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const { signal } = this.abort;

    this.fotos = Array.from(this.querySelectorAll('[data-flow-foto]'));
    this.teksten = /** @type {HTMLElement[]} */ (Array.from(this.querySelectorAll('[data-flow-tekst]')));
    this.kaart = /** @type {HTMLElement|null} */ (this.querySelector('.obflow-kaart'));
    /* Knop onder de tekst: gaat naar de productpagina van de actieve slide (data-flow-link),
       anders naar de sectie-link. Teksten komen uit de Liquid (data-label / data-product-label). */
    this.knop = /** @type {HTMLAnchorElement|null} */ (this.querySelector('[data-flow-knop]'));
    this.index = 0;
    if (this.fotos.length < 2 || this.fotos.length !== this.teksten.length) return;

    this.querySelector('[data-flow-vorige]')?.addEventListener('click', () => this.toon(this.index - 1), { signal });
    this.querySelector('[data-flow-volgende]')?.addEventListener('click', () => this.toon(this.index + 1), { signal });

    /* Theme editor: een slide-block kiezen toont die slide. */
    this.addEventListener(
      'shopify:block:select',
      (e) => {
        const n = this.teksten.indexOf(/** @type {HTMLElement} */ (e.target));
        if (n > -1) this.toon(n);
      },
      { signal }
    );

    this.toon(0);
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  /** @param {number} n */
  toon(n) {
    const total = this.fotos.length;
    this.index = (n + total) % total;
    this.fotos.forEach((el, k) => el.classList.toggle('is-active', k === this.index));
    this.teksten.forEach((el, k) => el.classList.toggle('is-active', k === this.index));
    if (this.kaart) this.kaart.dataset.kleur = this.teksten[this.index]?.dataset.flowKleur || '';
    if (this.knop) {
      const link = this.teksten[this.index]?.dataset.flowLink;
      const label = (link ? this.knop.dataset.productLabel : this.knop.dataset.label) || '';
      this.knop.href = link || this.knop.dataset.link || this.knop.href;
      this.knop.textContent = label;
      this.knop.hidden = !label;
    }
  }
}

if (!customElements.get('bob-obflow')) {
  customElements.define('bob-obflow', BobObflow);
}
